'use client'

import { Radio } from 'lucide-react'
import { useTranslations } from 'next-intl'

interface StartingSoonOverlayProps {
  eventTitle: string
}

export function StartingSoonOverlay({ eventTitle }: StartingSoonOverlayProps) {
  const t = useTranslations('demo')
  return (
    <div data-coach="audience-view-label" className="bg-gradient-to-r from-purple-600/30 via-fuchsia-600/30 to-pink-600/30 border-b border-purple-500/30 px-4 py-3">
      <div className="flex items-center gap-2">
        <div className="relative">
          <Radio className="h-4 w-4 text-purple-400" />
          <span className="absolute -top-0.5 -right-0.5 h-2 w-2 bg-purple-400 rounded-full animate-ping" />
        </div>
        <span className="text-sm font-semibold text-purple-200">{t('startingSoon', { eventTitle })}</span>
      </div>
    </div>
  )
}
